// React
import React, { createContext, useRef, useMemo, useContext } from "react";

// Libraries
import PropTypes from "prop-types";

const ListRefContext = createContext();

export const ListRefProvider = ({ children }) => {
	const listRef = useRef(null);
	const value = useMemo(() => {
		return { listRef };
	}, []);

	return <ListRefContext.Provider value={value}>{children}</ListRefContext.Provider>;
};

ListRefProvider.propTypes = {
	children: PropTypes.node,
};

export const useListRef = () => {
	const context = useContext(ListRefContext);
	return context;
};
